/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './PageLoadingContainer.scss';

import { array, bool, object, string } from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { getPathnameEnd } from 'services/Externals';

import PageLoadingSpinner from 'components/layouts/Navigation/PageLoadingSpinner';
import Optioner from 'components/shared/Optioner/Optioner';
import { REQUEST_STATES } from 'state/requests/RequestStatusReducer';
import { getHasAccountsError } from 'state/requests/RequestStatusSelectors';
import { isDashboardOrAccounts } from 'state/router/RouterSelectors';

const PageLoadingContainer = ({
  children,
  hasDataError = false,
  hasError,
  name,
  requestStates,
  requestStatus,
  includeBlur = true,
  isDashboardOrAccounts
}) => {
  const hasStateRequestError = requestStates && requestStates.some(state => requestStatus[state] === REQUEST_STATES.error);
  const hasStateRequestOpened =
    requestStates &&
    requestStates.some(
      (state) => requestStatus[state] === REQUEST_STATES.requested
    );

  const pageComponentBlurOverlay =
    includeBlur && (!hasStateRequestError && hasStateRequestOpened)
      ? 'page-loading-overlay-blur'
      : '';
  const hasFatalError = hasError || hasStateRequestError;

  return (
    <Fragment>
      <Optioner
        val={{
          hasDataError,
          hasFatalError,
          hasStateRequestError,
          hasStateRequestOpened
        }}>
        {{
          hasDataError: <Redirect to="/excess-accounts" />,
          hasFatalError: (
            <Redirect
              to={
                window.location
                  ? `${getPathnameEnd(window.location.pathname)}/error`
                  : '/error'
              }
            />
          ),
          hasStateRequestError: (
            <Redirect
              to={
                window.location
                  ? `${getPathnameEnd(window.location.pathname)}/error`
                  : '/error'
              }
            />
          ),
          hasStateRequestOpened: (
            <PageLoadingSpinner
              name={name}
              bypassLoader={isDashboardOrAccounts}
            />
          )
        }}
      </Optioner>
      {!hasFatalError && includeBlur && (
        <div
          className={isDashboardOrAccounts ? '' : `${pageComponentBlurOverlay}`}>
          {children}
        </div>
      )}
    </Fragment>
  );
};

PageLoadingContainer.propTypes = {
  hasError: bool.isRequired,
  name: string.isRequired,
  requestStates: array.isRequired,
  requestStatus: object.isRequired,
  includeBlur: bool
};

const mapStateToProps = (state) => ({
  requestStatus: state.requestStatus,
  hasAccountsError: getHasAccountsError(state),
  isDashboardOrAccounts: isDashboardOrAccounts(state)
});

export default connect(mapStateToProps)(PageLoadingContainer);
